import dispatcher from "./../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import GraphDashboardContants from "./../Constants/GraphDashboardConstants";

let result = null;
let equipmentStatusDistribution = null;
let InspectionKpi = null;
let TicketKpiRes = null;
let equipmentTicketRes = null;
let OrgKpiRes = null;
let DashboardSummaryRes = null;
class GraphDashboardStore extends EventEmitter {
  getResult() {
    return result;
  }
  setResult(res) {
    result = res;
  }
  getequipmentStatusDistributionResult() {
    return equipmentStatusDistribution;
  }
  setequipmentStatusDistributionResult(res) {
    equipmentStatusDistribution = res;
  }

  getInspectionKpiResult() {
    return InspectionKpi;
  }
  setInspectionKpiResult(res) {
    InspectionKpi = res;
  }

  getTicketKpiResult() {
    return TicketKpiRes;
  }
  setTicketKpiResult(res) {
    TicketKpiRes = res;
  }

  getOrgKpiResult() {
    return OrgKpiRes;
  }
  setOrgKpiResult(res) {
    OrgKpiRes = res;
  }

  getEquipmentTicketKpiResult() {
    return equipmentTicketRes;
  }
  setEquipmentTicketKpiResult(res) {
    equipmentTicketRes = res;
  }

  getDashboardSummaryResult() {
    return DashboardSummaryRes;
  }

  setDashboardSummaryResult(res) {
    DashboardSummaryRes = res;
  }

  emitChange(eventName) {
    this.emit(eventName);
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }
  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }
  handleCallback(action) {
    switch (action.type) {
      case GraphDashboardContants.GET_DASHBOARD_GRAPH_SUCCESS:
        this.setResult(action.result);
        break;
      case GraphDashboardContants.GET_DASHBOARD_GRAPH_FAILURE:
        this.setResult(action.result);
      case GraphDashboardContants.GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_SUCCESS:
        this.setequipmentStatusDistributionResult(action.result);
        break;
      case GraphDashboardContants.GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_FAILURE:
        this.setequipmentStatusDistributionResult(action.result);
        break;
      case GraphDashboardContants.GET_INSPECTION_KPI_DATA_SUCCESS:
        this.setInspectionKpiResult(action.result);
        break;
      case GraphDashboardContants.GET_INSPECTION_KPI_DATA_FAILURE:
        this.setInspectionKpiResult(action.result);
        break;
      case GraphDashboardContants.GET_TICKET_KPI_DATA_SUCCESS:
        this.setTicketKpiResult(action.result);
        break;
      case GraphDashboardContants.GET_TICKET_KPI_DATA_FAILURE:
        this.setTicketKpiResult(action.result);
        break;
      case GraphDashboardContants.GET_EQUIPMENT_TICKET_KPI_DATA_SUCCESS:
        this.setEquipmentTicketKpiResult(action.result);
        break;
      case GraphDashboardContants.GET_EQUIPMENT_TICKET_KPI_DATA_FAILURE:
        this.setEquipmentTicketKpiResult(action.result);
        break;
      case GraphDashboardContants.GET_ORG_KPI_DATA_SUCCESS:
        this.setOrgKpiResult(action.result);
        break;
      case GraphDashboardContants.GET_ORG_KPI_DATA_FAILURE:
        this.setOrgKpiResult(action.result);
        break;
      case GraphDashboardContants.GET_DASHBOARD_SUMMARY_DATA_SUCCESS:
        this.setDashboardSummaryResult(action.result);
        break;
      case GraphDashboardContants.GET_DASHBOARD_SUMMARY_DATA_FAILURE:
        this.setDashboardSummaryResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const graphDashboardStore = new GraphDashboardStore();
dispatcher.register(
  graphDashboardStore.handleCallback.bind(graphDashboardStore)
);
export default graphDashboardStore;
